import {QueryKamContactRequestModel} from '../models/query-kam-contact-reques.model';
import {QueryKamContactResponseModel} from '../models/query-kam-contact-response.model';
import {HttpServiceBase} from '../../../core/services/http-service-base';

export abstract class IProjectsContactService extends HttpServiceBase{
    public abstract queryKamContact( requestData?: QueryKamContactRequestModel ): Promise<QueryKamContactResponseModel>;
}

